import { GridColumn, GridRow } from 'app/layouts/grid';
import React from 'react';
import { TenantProfileSetting } from './tenant/index';
import { UserProfileSetting } from './user';
import { Spacer } from 'app/layouts/generic';
import useScreenSize from 'hooks/size';

export const ProfileSettings = () => {
  const { isMiniDesktop } = useScreenSize();
  return (
    <GridRow
      num_of_columns={isMiniDesktop ? 3 : 4}
      tabletStyles={{ gridTemplateColumns: 'repeat(1,1fr)', gap: 0 }}
      mobileStyles={{ gap: 0 }}
    >
      <GridColumn>
        <UserProfileSetting />
        <Spacer multiple={3} />
      </GridColumn>
      <GridColumn span={2}>
        <TenantProfileSetting />
      </GridColumn>
    </GridRow>
  );
};
